import { useState } from "react";
import ChangePayout from "./ChangePayout";
import bankImage from "../../assetsStatic/bank.png";
import paypalImage from "../../assetsStatic/paypal.png";
import bitcoinImage from "../../assetsStatic/bitcoin.png";
const NoPayoutSetPage = () => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <div className='NoPayOutSetContainer'>
        <div className='DummyImage'>
          <h2 className='payoutTitle'>Choose a payout option</h2>
          <div className='flexnPayOption'>
            <div>
              <h4>Bank transfer</h4>
              <div className='holder73645'>
                <img src={bankImage} />
              </div>
              <p>
                Get paid directly into your bank <br /> account. Transfer would take 7 working days
              </p>
              <a href='#'>Learn more</a>
            </div>
            <div>
              <h4>PayPal</h4>
              <div className='holder73645'>
                <img src={paypalImage} />
              </div>
              <p>
                Get paid directly into your PayPal <br /> account. Transfer would take 7 working days
              </p>
              <a href='#'>Learn more</a>
            </div>
            <div>
              <h4>Hubcoin wallet</h4>
              <div className='holder73645'>
                {" "}
                <img src={bitcoinImage} />{" "}
              </div>
              <p>
                Get paid directly into your Hubcoin <br /> wallet. Hubcoin can be used buy and sell in the hub platform
              </p>
              <a href='#'>Learn more</a>
            </div>
          </div>
        </div>

        <div className='SelectPayOutButton'>
          <button onClick={() => setOpenModal(true)} className='btn-selectPayout555'>
            Select PayOut
          </button>
        </div>
      </div>
      {openModal && <ChangePayout updateModal={setOpenModal} />}
    </>
  );
};

export default NoPayoutSetPage;
